<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="shelf_life_manufacture" name="shelf_life_manufacture" rules="required" v-slot="{ errors }">
              <small class="label">Shelf-life from manufacture</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="shelf_life_manufacture" class="w-full" v-model="form.shelf_life_manufacture" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="storage_req_temp" name="storage_req_temp" rules="required" v-slot="{ errors }">
              <small class="label">Storage requirements and temperature</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="storage_req_temp" class="w-full"  v-model="form.storage_req_temp" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="min_shelf_life_delivery" name="min_shelf_life_delivery" rules="required" v-slot="{ errors }">
              <small class="label">Minimum shelf-life on delivery</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.min_shelf_life_delivery" name="min_shelf_life_delivery" class="w-full" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="storage_opening" name="storage_opening" rules="required" v-slot="{ errors }">
              <small class="label">Storage conditions on opening</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.storage_opening" name="storage_opening" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>



        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_raw_material_storage_shelf_life_complete"  button="submit" class="ml-auto mt-2" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";


  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          is_staff_trained: false,
          is_protective_clothing_available: false,
          is_protective_clothing_laundered: false,
          is_change_eating_available: false,
          is_personal_items: false,
          is_medical_prior_employment: false,
          is_medical_foreign_vacation: false,
          is_medical_absence: false
        },
        id: null,
        status: {}
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    components: {
      'v-select': vSelect,
    },
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_raw_material_storage_shelf_life_complete ? this.onClickUpdate() : this.onClickCreate()
      },
      async onClickUpdate() {
        this.$vs.loading()
        try {
          const data= (await SupplierRawMaterialRepository.UpdateRawMaterialStorage(this.id, this.form))
          this.showSuccessMessage('Raw Material Storage Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          const data= (await SupplierRawMaterialRepository.CreateRawMaterialStorage(this.form))
          this.showSuccessMessage('Raw Material Storage Details Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStorage(this.id)).data
        this.form =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadStatus()
      if (this.status.is_raw_material_storage_shelf_life_complete ) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
